export default __webpack_public_path__ + "static/media/filter.b932eafb.svg";